import { SetStateAction, useEffect, useRef, useState } from 'react'
import { TabelaSubArea } from './components/tabela'
import { ContainerSubArea } from './styles'
import { useHistory } from 'react-router'
import { useLogic } from '../../../context/useLogic'
import { getPropriedade } from '../../../services/Propriedades'
import { localConfig } from '../../../Configs/localConfig'
import { getTalhaoCultivavel } from '../../../services/TalhaoSafra'
import { formatarValor } from '../../../utils'
import ViewPage from '../../../Components/ViewPage'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { MostrarSubArea } from './components/subarea'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'

const SubAreaNovo: React.FC = () => {
  const history = useHistory()
  const { checkSafra } = useLogic()

  const refSelectTalhao = useRef(null)

  // TABELA
  const [dataPropriedade, setdataPropriedade] = useState([])
  const [dataTalhaoSafra, setDataTalhaoSafra] = useState([])
  const [dadosNovos, setDadosNovos] = useState([])
  const [loadingTable, setLoadingTable] = useState(false)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [open, setOpen] = useState(false)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [buscar_tabela, setBuscar_tabela] = useState<string>('')
  const [selecionar_propriedade, setSelecionar_propriedade] = useState<string>('')
  const [selecionar_propriedade_id, setSelecionar_propriedade_id] = useState<number>(null)
  const [nomePropriedade, setNomePropriedade] = useState('')
  const [dadosEstatisticas, setDadosEstatisticas] = useState([])
  const [dadosResultado, setDadosResultado] = useState([])

  //SUBAREA
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [editTalhaoSafraSubArea, setEditTalhaoSafraSubArea] = useState([])
  const [update, setUpdate] = useState(0)
  const [codPropri, setcodPropri] = useState(null)
  const [abrirMapa, setAbrirMapa] = useState<boolean>(false)
  const [editIndexSubTalhao, setEditIndexSubTalhao] = useState<number>()

  const listPropriedade = async () => {
    const resp = await getPropriedade('')
    setdataPropriedade(resp.data.itens)
  }

  const listTalhaoSafra = async (codPropriedade) => {
    const { codSafra } = localConfig()
    setLoadingTable(true)
    const resp = await getTalhaoCultivavel({
      codSafra: Number(codSafra),
      embed: 'sub_area',
      codPropriedade,
    })
    setNomePropriedade(resp?.data?.itens[0]?.propriedade_nome)
    setDataTalhaoSafra(resp.data.itens)
    //@ts-ignore
    const novodados = resp.data.itens.flatMap((item) =>
      item.sub_area.map((sub) => ({
        nome: item.nome,
        area: item.area,
        nome_sub: sub.nome,
        area_sub: sub.area,
      }))
    )
    setDadosNovos(novodados)

    const resultado = novodados.reduce(
      (soma, item) => {
        return {
          area: soma.area + parseFloat(item.area),
          area_subarea: soma.area_subarea + parseFloat(item.area_sub),
        }
      },
      {
        area: 0,
        area_subarea: 0,
      }
    )

    const resultadoFinal = [
      {
        totalizado_area: formatarValor(resultado?.area),
        totalizado_area_subarea: formatarValor(resultado?.area_subarea),
      },
    ]

    gerarTabela(novodados)
    gerarTabela2(resultadoFinal, novodados.length)
    setLoadingTable(false)
  }

  function gerarTabela(dados) {
    const data = dados?.map((item) => {
      return [
        { text: item?.nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: formatarValor(parseFloat(item?.area)),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'right',
        },
        { text: item?.nome_sub, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: formatarValor(parseFloat(item?.area_sub)),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'right',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*'],
          body: [
            [
              { text: 'Nome talhão', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Área/ha', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Subárea', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Área subárea/ha', style: 'tableHeader', fontSize: 9, alignment: 'center' },
            ],
            ...data,
          ],
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]

    setDadosEstatisticas(table)
  }

  function gerarTabela2(dados, length) {
    const data = dados?.map((item) => {
      return [
        { text: length, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: item.totalizado_area,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
        // { text: lengthSub, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: item.totalizado_area_subarea,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*'],
          body: [
            [
              {
                text: 'Total subáreas',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total área',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total área subáreas',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
            ],
            ...data,
          ],
          margin: [0, 50, 0, 0],
          alignment: 'center',
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]

    setDadosResultado(table)
  }

  const handleChangePropriedade = (data) => {
    setDataTalhaoSafra([])
    setcodPropri(data)
    listTalhaoSafra(data)
  }

  const handleClickEdit = (data) => {
    const dados = [...dataTalhaoSafra]
    const find = dados.filter((info) => info.cod === data)

    setEditTalhaoSafraSubArea(find)
    setUpdate(data)
    setAbrirMapa(true)
  }

  const fecharMapa = (data) => {
    setAbrirMapa(data)
    setEditTalhaoSafraSubArea([])
    setUpdate(0)
    setEditIndexSubTalhao(null)
  }

  useEffect(() => {
    listPropriedade()

    const idDaSafra = checkSafra('/talhao/subarea')

    if (!idDaSafra) {
      history.push('/home')
    }

    // refSelectTalhao?.current.focus()
  }, [])

  useEffect(() => {
    if (selecionar_propriedade_id) {
      handleChangePropriedade(selecionar_propriedade_id)
    }
  }, [selecionar_propriedade_id])

  return (
    <ContainerSubArea>
      <ViewPage
        title='Subárea'
        rotina={30}
        newHide
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        onPermission={setPermissions}
      >
        <div style={{marginBottom: 10}}> <TitleH1>Subárea</TitleH1></div>
        <TabelaSubArea
          loading={loadingTable}
          list_subareas={dataTalhaoSafra}
          deletar={undefined}
          editar={handleClickEdit}
          permissao={{
            cod: 0,
            acesso: 0,
            alteracao: 0,
            inclusao: 0,
            exclusao: 0,
            cod_rotina: 0,
            rotina_nome: '',
            cod_perfil: 0,
            perfil_nome: '',
          }}
          total={0}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          setNome_item_atual={setNome_item_atual}
          buscarTabela={buscar_tabela}
          setBuscarTabela={setBuscar_tabela}
          fake_loading={fake_loading}
          selecionar_propriedade={selecionar_propriedade}
          setSelecionar_propriedade={setSelecionar_propriedade}
          selecionar_propriedade_id={selecionar_propriedade_id}
          setSelecionar_propriedade_id={setSelecionar_propriedade_id}
          lista_propriedades={dataPropriedade}
          dadosEstatisticas={dadosEstatisticas}
          dadosResultado={dadosResultado}
        />
        <MostrarSubArea
          codPropri={codPropri}
          onClose={fecharMapa}
          listTalhoesRecord={editTalhaoSafraSubArea}
          listTalhaoSafra={listTalhaoSafra}
          update={update}
          permissions={permissions}
          visible={abrirMapa}
          editIndexSubTalhao={editIndexSubTalhao}
          setEditIndexSubTalhao={setEditIndexSubTalhao}
        />
      </ViewPage>
    </ContainerSubArea>
  )
}

export default SubAreaNovo
